import { onError } from 'apollo-link-error';

// Error handling
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) graphQLErrors.map(({ message, locations, path }) => message);

  if (networkError) {
    return networkError;
  }
});

export default errorLink;
